module.exports = __webpack_public_path__ + "media/correct.a8250f13.wav";